import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import createHistory from 'history/createBrowserHistory';
import {createLogger} from "redux-logger"
import thunk from 'redux-thunk';
import promise from "redux-promise-middleware"
import PlumbersStateReducer from './modules/plumbers';
import sagas from './sagas';


export function browserHistory () {
  createHistory()
}  

export function configureStore() {
  const sagaMiddleware = createSagaMiddleware();
  
  let middleware = applyMiddleware(
    sagaMiddleware,
    promise(),
    thunk,
    createLogger(),

    );


  if (process.env.NODE_ENV !== 'production') {
    const devToolsExtension = window.devToolsExtension;
    if (typeof devToolsExtension === 'function') {
      middleware = compose(middleware, devToolsExtension());
    }
  }

 const store = createStore(PlumbersStateReducer, middleware);
  sagaMiddleware.run(sagas);

return store
}


// WEBPACK FOOTER //
// ./src/Store.js